import { useQuery } from "react-query";

import { CustomerNote } from "../../models";
import { getAll } from "../../api/generic-api";
import { RQ } from "../../globals/enums";

export const useCustomerNotesByCustomer = (customerId?: string) => {
  return useQuery<CustomerNote[], Error>(
    [RQ.CUSTOMER_NOTES, customerId],
    () => getAll(`customers/${customerId}/customer-notes`),
    {
      enabled: Boolean(customerId),
    }
  );
};
